import useGalleryScenes from '../hooks/useGalleryScenes';
import { useAtom } from 'jotai';
import { showPanoramaViewAtom } from '../states/planner';

export const PanoramaButton = () => {
  const [galleryScenes] = useGalleryScenes();
  const [, setShowPanoramaView] = useAtom(showPanoramaViewAtom);

  if (!galleryScenes || galleryScenes.length == 0) return null;

  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <button
      onClick={() => setShowPanoramaView(true)}
      className="left-32 rounded-md bg-black bg-opacity-50 px-3 py-1 text-sm text-white transition hover:scale-105"
    >
      Visa 360
    </button>
  );
};
